import { Empty, Typography, Space } from "antd";
import React from "react";

/**
 * Convenience component to display a placeholder with replaced default image and text when no data is found
 * @param imgUrl
 * @param text
 * @param height
 * @param maxWidth
 * @param action
 * @param minHeight
 * @returns {JSX.Element}
 * @constructor
 */
const Placeholder = ({
    imgUrl = 'https://storage.googleapis.com/finiat-web-static-resources/placeholders/bar-placeholder-2.png',
    text = 'No Data Found...',
    height = 200,
    maxWidth = 400,
    action,
    minHeight = 300,
    textSize='text-1xl'
}) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                minHeight, // Adjust as needed
                flexDirection: 'column', // Ensures column alignment
                textAlign: 'center', // Centers text alignment
            }}
        >
            <Empty
                image={imgUrl}
                imageStyle={{
                    height,
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                }}
                style={{
                    maxWidth,
                    textAlign: 'center',
                }}
                description={null}
            />
            <div className={'w-[500px] mx-auto py-4 my-6'}>
                <Typography.Text
                        className={`text-gray-900 ${textSize}`}
                        style={{
                            fontSize: '1rem',
                            width: 600,
                            textAlign: 'left', // Ensures text alignment for multiline text
                        }}
                    >
                        {text}
                </Typography.Text>
            </div>
            {action && (
                <div
                    style={{
                        marginTop: '16px', // Ensure spacing from the description
                    }}
                >
                    {action}
                </div>
            )}
        </div>
    );
};

export default Placeholder;
